var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"value":_vm.alertData,"timeout":"5000","color":_vm.color}},[_vm._v(_vm._s(_vm.alertData? _vm.alertData.txt:'')+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }